import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

// Cookie Categories (Ardentis PMS - Compliant with Swiss LPD/nFADP and GDPR)
const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_FUNCTIONALITY = "functionality";

// Google Consent Mode v2 Services
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage';
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage';
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage';

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];

function gtag() {
    dataLayer.push(arguments);
}

// Set default consent to 'denied' (GDPR/LPD compliance - consent before tracking)
gtag('consent', 'default', {
    [SERVICE_ANALYTICS_STORAGE]: 'denied',
    [SERVICE_FUNCTIONALITY_STORAGE]: 'denied',
    [SERVICE_PERSONALIZATION_STORAGE]: 'denied',
});

/**
 * Update Google Tag Manager consent based on user's cookie preferences
 * Compliant with Swiss Federal Act on Data Protection (nFADP) and GDPR
 */
function updateGtagConsent() {
    gtag('consent', 'update', {
        [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
        [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedService(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedService(SERVICE_PERSONALIZATION_STORAGE, CAT_FUNCTIONALITY) ? 'granted' : 'denied',
    });
}

/**
 * Load Google Tag Manager script only if analytics consent is granted
 * GDPR/LPD compliance: GTM must not load without user consent
 */
function loadGoogleTagManager() {
    // Check if GTM is already loaded
    if (window.gtmLoaded) {
        return;
    }

    // Check if analytics consent is granted
    if (CookieConsent.acceptedCategory(CAT_ANALYTICS)) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-MCLFJPV');

        window.gtmLoaded = true;
    }
}


CookieConsent.run({
    // Ardentis Cookie Consent Configuration
    // Compliant with Swiss LPD/nFADP and GDPR for healthcare data

    // Cookie configuration - IMPORTANT pour persister le consentement
    cookie: {
        name: 'cc_cookie',
        domain: window.location.hostname,
        path: '/',
        expiresAfterDays: 182, // 6 mois
        sameSite: 'Lax',
    },

    // Trigger consent update when user choices change
    onFirstConsent: () => {
        loadGoogleTagManager();
        updateGtagConsent();
    },
    onConsent: () => {
        loadGoogleTagManager();
        updateGtagConsent();
    },
    onChange: () => {
        loadGoogleTagManager();
        updateGtagConsent();
    },

    // Configure categories and services
    categories: {
        [CAT_NECESSARY]: {
            enabled: true,
            readOnly: true,
            services: {
                'cc_cookie': {
                    label: 'Cookie de consentement',
                },
                'patient_category': {
                    label: 'Catégorie de patient',
                },
                'rdv_user_phone_valid': {
                    label: 'Validation du téléphone',
                },
                'XSRF-TOKEN': {
                    label: 'Protection CSRF',
                },
                'ardentis_session': {
                    label: 'Session sécurisée',
                }
            }
        },
        [CAT_ANALYTICS]: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,
                    },
                    {
                        name: '_gid',
                    }
                ]
            },
            services: {
                [SERVICE_ANALYTICS_STORAGE]: {
                    label: 'Google Analytics - Analyse de fréquentation',
                }
            }
        },
        [CAT_FUNCTIONALITY]: {
            services: {
                [SERVICE_FUNCTIONALITY_STORAGE]: {
                    label: 'Préférences utilisateur (langue, paramètres d\'affichage)',
                },
                [SERVICE_PERSONALIZATION_STORAGE]: {
                    label: 'Personnalisation de l\'expérience (recommandations)',
                },
            }
        }
    },

    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: true
        }
    },

    language: {
        default: "fr",
        autoDetect: "document",
        translations: {
            fr: {
                consentModal: {
                    title: "Gestion des cookies",
                    description: "Nous utilisons des cookies pour garantir le bon fonctionnement de notre plateforme de prise de rendez-vous et améliorer votre expérience. Les cookies strictement nécessaires sont indispensables pour l'authentification et la sécurité de vos données de santé.",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Refuser les cookies optionnels",
                    showPreferencesBtn: "Gérer mes préférences",
                    footer: "<a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Politique de confidentialité</a>\n<a href=\"https://www.ardentis.ch/conditions-generales/\" target=\"_blank\">Conditions générales</a>"
                },
                preferencesModal: {
                    title: "Préférences de confidentialité",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Refuser les cookies optionnels",
                    savePreferencesBtn: "Enregistrer mes préférences",
                    closeIconLabel: "Fermer",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Utilisation des cookies",
                            description: "Nous utilisons des cookies pour assurer le fonctionnement sécurisé de la plateforme de prise de rendez-vous Ardentis et analyser son utilisation afin d'améliorer nos services. Vos données de santé sont protégées conformément à la Loi fédérale sur la protection des données (LPD) suisse et au RGPD."
                        },
                        {
                            title: "Cookies strictement nécessaires <span class=\"pm__badge\">Toujours actifs</span>",
                            description: "Ces cookies sont indispensables au fonctionnement de la plateforme. Ils permettent l'authentification sécurisée, la protection contre les attaques CSRF, et la gestion de votre session. Sans ces cookies, vous ne pourriez pas prendre rendez-vous ou accéder à votre espace patient.",
                            linkedCategory: CAT_NECESSARY,
                            cookieTable: {
                                headers: {
                                    name: "Cookie",
                                    domain: "Fonction",
                                    description: "Description",
                                    expiration: "Durée"
                                },
                                body: [
                                    {
                                        name: "cc_cookie",
                                        domain: "Consentement",
                                        description: "Enregistre vos préférences de cookies",
                                        expiration: "6 mois"
                                    },
                                    {
                                        name: "patient_category",
                                        domain: "Prise de RDV",
                                        description: "Type de patient (nouveau/existant)",
                                        expiration: "Session"
                                    },
                                    {
                                        name: "rdv_user_phone_valid",
                                        domain: "Authentification",
                                        description: "Validation du numéro de téléphone",
                                        expiration: "Session"
                                    },
                                    {
                                        name: "XSRF-TOKEN",
                                        domain: "Sécurité",
                                        description: "Protection contre les attaques CSRF",
                                        expiration: "2 heures"
                                    },
                                    {
                                        name: "ardentis_session",
                                        domain: "Session",
                                        description: "Identifiant de session sécurisée",
                                        expiration: "2 heures"
                                    }
                                ]
                            }
                        },
                        {
                            title: "Cookies analytiques",
                            description: "Ces cookies nous permettent de mesurer l'audience de notre site et d'analyser son utilisation (pages visitées, durée des visites). Ces données sont anonymisées et nous aident à améliorer votre expérience. Nous utilisons Google Analytics via Google Tag Manager.",
                            linkedCategory: CAT_ANALYTICS,
                            cookieTable: {
                                headers: {
                                    name: "Cookie",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Durée"
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Identifiant anonyme pour analyser l'utilisation du site",
                                        expiration: "2 ans"
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Identifiant anonyme pour les statistiques de session",
                                        expiration: "24 heures"
                                    }
                                ]
                            }
                        },
                        {
                            title: "Cookies de fonctionnalité",
                            description: "Ces cookies permettent de mémoriser vos préférences (langue, paramètres d'affichage) pour vous offrir une expérience personnalisée lors de vos prochaines visites.",
                            linkedCategory: CAT_FUNCTIONALITY,
                        },
                        {
                            title: "Plus d'informations",
                            description: "Pour toute question concernant l'utilisation de vos données personnelles et vos droits (accès, rectification, suppression), veuillez consulter notre <a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">politique de confidentialité</a> ou nous contacter via notre site web <a href=\"https://www.ardentis.ch/\" target=\"_blank\">www.ardentis.ch</a>."
                        }
                    ]

                }
            },
            en: {
                consentModal: {
                    title: "Cookie Settings",
                    description: "We use cookies to ensure the secure and proper functioning of the Ardentis appointment booking platform and to improve your user experience. Strictly necessary cookies are essential for authentication, security, and the protection of health-related data.",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject optional cookies",
                    showPreferencesBtn: "Manage preferences",
                    footer: "<a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Privacy Policy</a>\n<a href=\"https://www.ardentis.ch/conditions-generales/\" target=\"_blank\">Terms & Conditions</a>"
                },
                preferencesModal: {
                    title: "Privacy Preferences",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject optional cookies",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Use of cookies",
                            description: "Cookies are used to ensure the secure operation of the Ardentis appointment booking platform and to analyze its usage in order to continuously improve our services. Health-related data is processed in accordance with the Swiss Federal Act on Data Protection (FADP) and, where applicable, the General Data Protection Regulation (GDPR)."
                        },
                        {
                            title: "Strictly necessary cookies <span class=\"pm__badge\">Always active</span>",
                            description: "These cookies are indispensable for the technical operation and security of the platform. They support secure authentication, protection against malicious requests (CSRF), and session management. Disabling these cookies would prevent access to certain essential services, including appointment booking and the patient area.",
                            linkedCategory: CAT_NECESSARY,
                            cookieTable: {
                                headers: {
                                    name: "Cookie",
                                    domain: "Purpose",
                                    description: "Description",
                                    expiration: "Retention"
                                }
                            }
                        },
                        {
                            title: "Analytics cookies",
                            description: "These cookies allow us to collect anonymized statistical information about website usage (such as visited pages and navigation patterns). The data helps us enhance performance and usability. We use Google Analytics via Google Tag Manager.",
                            linkedCategory: CAT_ANALYTICS
                        },
                        {
                            title: "Functionality cookies",
                            description: "These cookies store user preferences (such as language or interface settings) in order to provide a more personalized browsing experience.",
                            linkedCategory: CAT_FUNCTIONALITY,
                        },
                        {
                            title: "Further information",
                            description: "For more details on how personal data is processed and to learn about your rights (including access, rectification, and erasure), please refer to our <a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Privacy Policy</a>."
                        }
                    ]
                }
            },
            de: {
                consentModal: {
                    title: "Cookie-Einstellungen",
                    description: "Wir verwenden Cookies, um den sicheren und ordnungsgemäßen Betrieb der Ardentis-Terminplattform zu gewährleisten und die Nutzererfahrung zu verbessern. Technisch notwendige Cookies sind für die Authentifizierung, Sicherheit und den Schutz gesundheitsbezogener Daten erforderlich.",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Optionale Cookies ablehnen",
                    showPreferencesBtn: "Einstellungen verwalten",
                    footer: "<a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Datenschutzerklärung</a>\n<a href=\"https://www.ardentis.ch/conditions-generales/\" target=\"_blank\">Allgemeine Bedingungen</a>"
                },
                preferencesModal: {
                    title: "Datenschutzpräferenzen",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Optionale Cookies ablehnen",
                    savePreferencesBtn: "Einstellungen speichern",
                    closeIconLabel: "Schließen",
                    serviceCounterLabel: "Dienst|Dienste",
                    sections: [
                        {
                            title: "Verwendung von Cookies",
                            description: "Cookies werden eingesetzt, um den sicheren Betrieb der Ardentis-Terminplattform zu gewährleisten und deren Nutzung zu analysieren, damit wir unsere Dienstleistungen fortlaufend verbessern können. Die Verarbeitung gesundheitsbezogener Daten erfolgt gemäß dem Schweizer Datenschutzgesetz (DSG) sowie – sofern anwendbar – der Datenschutz-Grundverordnung (DSGVO)."
                        },
                        {
                            title: "Technisch notwendige Cookies <span class=\"pm__badge\">Immer aktiv</span>",
                            description: "Diese Cookies sind für den technischen Betrieb und die Sicherheit der Plattform zwingend erforderlich. Sie ermöglichen eine sichere Authentifizierung, den Schutz vor schädlichen Anfragen (CSRF) sowie die Sitzungsverwaltung. Ohne diese Cookies können wesentliche Funktionen, insbesondere die Terminbuchung und der Zugriff auf den Patientenbereich, nicht bereitgestellt werden.",
                            linkedCategory: CAT_NECESSARY
                        },
                        {
                            title: "Analyse-Cookies",
                            description: "Diese Cookies ermöglichen die Erhebung anonymisierter statistischer Informationen über die Nutzung der Website (z. B. besuchte Seiten und Navigationsverhalten). Die Daten dienen der Optimierung von Leistung und Benutzerfreundlichkeit. Wir verwenden Google Analytics über Google Tag Manager.",
                            linkedCategory: CAT_ANALYTICS
                        },
                        {
                            title: "Funktions-Cookies",
                            description: "Diese Cookies speichern Nutzereinstellungen (wie Sprache oder Anzeigeoptionen), um ein personalisiertes Nutzungserlebnis zu ermöglichen.",
                            linkedCategory: CAT_FUNCTIONALITY,
                        },
                        {
                            title: "Weitere Informationen",
                            description: "Ausführliche Informationen zur Verarbeitung personenbezogener Daten und zu Ihren Rechten finden Sie in unserer <a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Datenschutzerklärung</a>."
                        }
                    ]
                }
            },
            it: {
                consentModal: {
                    title: "Impostazioni dei cookie",
                    description: "Utilizziamo i cookie per garantire il funzionamento sicuro e corretto della piattaforma di prenotazione Ardentis e per migliorare l’esperienza dell’utente. I cookie strettamente necessari sono indispensabili per l’autenticazione, la sicurezza e la protezione dei dati sanitari.",
                    acceptAllBtn: "Accetta tutti",
                    acceptNecessaryBtn: "Rifiuta i cookie opzionali",
                    showPreferencesBtn: "Gestisci preferenze",
                    footer: "<a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Informativa sulla privacy</a>\n<a href=\"https://www.ardentis.ch/conditions-generales/\" target=\"_blank\">Condizioni generali</a>"
                },
                preferencesModal: {
                    title: "Preferenze di riservatezza",
                    acceptAllBtn: "Accetta tutti",
                    acceptNecessaryBtn: "Rifiuta i cookie opzionali",
                    savePreferencesBtn: "Salva preferenze",
                    closeIconLabel: "Chiudi",
                    serviceCounterLabel: "Servizio|Servizi",
                    sections: [
                        {
                            title: "Uso dei cookie",
                            description: "I cookie sono utilizzati per garantire il funzionamento sicuro della piattaforma di prenotazione Ardentis e per analizzarne l’utilizzo al fine di migliorare costantemente i nostri servizi. I dati sanitari sono trattati conformemente alla Legge federale svizzera sulla protezione dei dati (LPD) e, ove applicabile, al Regolamento generale sulla protezione dei dati (RGPD)."
                        },
                        {
                            title: "Cookie strettamente necessari <span class=\"pm__badge\">Sempre attivi</span>",
                            description: "Questi cookie sono essenziali per il funzionamento tecnico e la sicurezza della piattaforma. Consentono l’autenticazione sicura, la protezione da richieste dannose (CSRF) e la gestione della sessione. La disattivazione di tali cookie potrebbe impedire l’accesso a funzionalità fondamentali, inclusa la prenotazione degli appuntamenti e l’area paziente.",
                            linkedCategory: CAT_NECESSARY
                        },
                        {
                            title: "Cookie analitici",
                            description: "Questi cookie raccolgono informazioni statistiche anonimizzate sull’utilizzo del sito (ad esempio pagine visitate e modalità di navigazione). I dati contribuiscono al miglioramento delle prestazioni e dell’usabilità. Utilizziamo Google Analytics tramite Google Tag Manager.",
                            linkedCategory: CAT_ANALYTICS
                        },
                        {
                            title: "Cookie di funzionalità",
                            description: "Questi cookie memorizzano le preferenze dell’utente (come lingua o impostazioni di visualizzazione) per offrire un’esperienza più personalizzata.",
                            linkedCategory: CAT_FUNCTIONALITY,
                        },
                        {
                            title: "Ulteriori informazioni",
                            description: "Per maggiori dettagli sul trattamento dei dati personali e sui diritti dell’utente, consultare la nostra <a href=\"https://www.ardentis.ch/politique-de-confidentialite/\" target=\"_blank\">Informativa sulla privacy</a>."
                        }
                    ]
                }
            }


        }
    },
    disablePageInteraction: true,
});
